import script from "./PaymentSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentSuccess.vue?vue&type=script&setup=true&lang=js"

import "./PaymentSuccess.vue?vue&type=style&index=0&id=9c64801e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c64801e"]])

export default __exports__